import classNames from 'classnames';
import exact from 'prop-types-exact';
import PropTypes from 'prop-types';
import React from 'react';

import Icon from '../Atoms/Icon';

const propTypes = exact({
  currentPage: PropTypes.number.isRequired,
  handleNextClick: PropTypes.func.isRequired,
  handlePreviousClick: PropTypes.func.isRequired,
  totalPages: PropTypes.number.isRequired,
});

function Pagination(props) {
  const previousClasses = classNames(
    'Pagination_navigationButton',
    'Pagination_navigationButton-previous',
    { disabled: props.currentPage <= 1 }
  );

  const nextClasses = classNames(
    'Pagination_navigationButton',
    'Pagination_navigationButton-next',
    { disabled: props.currentPage === props.totalPages }
  );
  return (
    <div className="Pagination">
      <div className="Pagination_navigation">
        <button type="button" onClick={props.handlePreviousClick} className={previousClasses}>
          <Icon id="arrow-left" blockName="Icon Pagination_icon" />
        </button>
      </div>
      <div className="Pagination_result">
        <span className="Pagination_resultValue">{props.currentPage}</span>
        <span className="Pagination_resultSplit">/</span>
        <span className="Pagination_resultValue">{props.totalPages}</span>
      </div>
      <div className="Pagination_navigation">
        <button type="button" onClick={props.handleNextClick} className={nextClasses}>
          <Icon id="arrow-right" blockName="Icon Pagination_icon" />
        </button>
      </div>
    </div>
  );
}

Pagination.propTypes = propTypes;

export default Pagination;
